
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy-app",
      function () {
        return require("private-next-pages/privacy-policy-app.js");
      }
    ]);
  